import { render, staticRenderFns } from "./ProfileFemale.vue?vue&type=template&id=0a6c087d&scoped=true"
import script from "./ProfileFemale.vue?vue&type=script&lang=js"
export * from "./ProfileFemale.vue?vue&type=script&lang=js"
import style0 from "./ProfileFemale.vue?vue&type=style&index=0&id=0a6c087d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c087d",
  null
  
)

export default component.exports